import {stringToCell} from '../helpers'

const CELL_TO_COLLAPSED_CELL = {
	TimeCell: 'TimeCell',
	TimeCellWithZero: 'TimeCellWithZero',
	true: 'BasicCell',
	BooleanCell: 'CollapsibleBooleanCell',
	MoneyCell: 'MoneyCellWithoutZero',
}

export const getDefaultCollapsedCellName = cellName => CELL_TO_COLLAPSED_CELL[cellName]

export const getCellComponent = (cell, fallback) => {
	const {collapsibleCell, cell: nonCollapsibelCell} = cell.column.columnDef

	const custom = stringToCell(collapsibleCell)

	const defaultCellName = CELL_TO_COLLAPSED_CELL[nonCollapsibelCell]
	const defaultCell = defaultCellName && stringToCell(defaultCellName)

	return custom || defaultCell || fallback
}
